import React, { Component } from 'react'
import { withApollo } from 'react-apollo'
import PropTypes from 'prop-types'
import { Typography, Form, Button, Row, Col, Icon, Modal, Select, Input, Checkbox, Pagination, Spin } from 'antd'
import { Link } from 'react-router-dom'
import { changeFormatdateSlip } from '../../../../../utils/formatdate'
import moment from 'moment'
import { UrlMeeting } from '../../../../../utils/auth'
import axios from 'axios';

const { Text } = Typography
const { Option } = Select;
const { TextArea } = Input;

const STATE = {
	ADD_DELEGATE_USER: 1,
	ADD_DELEGATE_NOTE: 2,
}

class ViewInviteMeeting extends Component {
	state = {
		id: "",
		type: "",
		showModal: false,
		showModalSuccess: false,
		showModalChangeUser: false,
		dropdownGroup: [],
		dropdownOrg: [],
		dropdownDivision: [],
		dropdownDepartment: [],
		searchNameInternal: "",
		groupCode: "",
		orgCode: "",
		inviteInternal: [],
		limitpaginateGuset: 10,
		totalpaginateGuset: 0,
		currentPaginateGuset: 1,
		showlistInviteExternal: [],
		countshowlistInviteExternal: 0,
		disableOther: false,
		loadingInternal: false,
		valueSelectOrg: "",
		valueSelectDep: "",
		valueSelectDiv: "",
		isCheckBox: "",
		isSearch: false,
		note: "",
		currentAddDelegateState: STATE.ADD_DELEGATE_USER,
	}
	componentDidMount = () => {
		this.fetchListOrg();
		this.fetchListGroup();
	}

	fetchListUser = (groupCode, orgcode, limit, offset, input) => {
		this.setState({ loadingInternal: true })
		axios.get(
         `${UrlMeeting()}/meeting/secure/searchemployee?groupID=${groupCode}&orgCode=${orgcode}&limit=${limit}&offset=${offset}&search=${input}`
      )
			.then(response => {
				const data = response.data.status.message.searchEmployeeByEmpCodesAndOrgCode
				this.setState({
               inviteInternal: data.data,
               totalpaginateGuset: data.total,
               isSearch: true,
               loadingInternal: false,
				})

            let item = document.getElementsByClassName("checkbox-listInviteInternal")

            for (let i = 0; i < item.length; i++) {
            console.log("pagxxxxe", item[i].getElementsByClassName("ant-checkbox"));
            item[i].getElementsByClassName("ant-checkbox")[0].classList.remove('ant-checkbox-checked');
   
            }
			}).catch(error => {
				this.setState({
					loadingInternal: false,
					isSearch: true,
				})
				console.error(`Error: ${error}`)
			})
	}
	clickChange = async (id, type) => {
		await this.setState({
			id,
			type,
			showModal: true
		})
		// console.log("id , type", this.state.id, this.state.type);
	}
	handleChangeUser = async (id, type) => {
		await this.setState({
			id,
			type,
			showModalChangeUser: true
		})
		// console.log("id , type", this.state.id, this.state.type);
	}

	handleOk = () => {
		this.props.clickAccept(this.state.id, this.state.type);
		this.setState({
			showModal: false,
			showModalSuccess: true
		})
		setTimeout(() => {
			this.setState({
				showModalSuccess: false
			})
		}, 1000);
	}

	handleCancel = () => {
		this.setState({
			showModal: false,
			showModalSuccess: false,
			showModalChangeUser: false,
			dropdownDivision: [],
			dropdownDepartment: [],
			searchNameInternal: "",
			loadingInternal: false,
			valueSelectOrg: "",
			valueSelectDep: "",
			valueSelectDiv: "",
			inviteInternal: [],
			disableOther: false,
			showlistInviteExternal: [],
			isSearch: false,
			note: "",
			currentAddDelegateState: STATE.ADD_DELEGATE_USER,
		})
	}
	fetchListGroup = () => {
		axios.get(`${UrlMeeting()}/meeting/secure/group/listgroupmeetingall`)
			.then(response => {
				const data = response.data
				// console.log("fetchListGroup", data);
				this.setState({
					dropdownGroup: data
				})
			}).catch(error => console.error(`Error: ${error}`))
	}
	fetchListOrg = () => {
		axios.get(`${UrlMeeting()}/meeting/secure/finddropdownbyorg/org/`)
			.then(response => {
				const data = response.data.status.message.fetchListOrgForTwoway
				// console.log("dropdownOrg", data);
				this.setState({
					dropdownOrg: data
				})

			}).catch(
				error => console.error(`Error: ${error}`)
			)
	}
	fetchListDiv = (id) => {
		axios.get(`${UrlMeeting()}/meeting/secure/finddropdownbyorg/division/?id=${id}`)
			.then(response => {
				const data = response.data.status.message.fetchListDivisionForTwoway
				this.setState({
					dropdownDivision: data
				})

			}).catch(
				error => console.error(`Error: ${error}`)
			)
	}
	fetchListDep = (id) => {
		axios.get(`${UrlMeeting()}/meeting/secure/finddropdownbyorg/department/?id=${id}`)
			.then(response => {
				const data = response.data.status.message.fetchListDepartmentForTwoway
				// console.log("dropdownDepartment", data);
				this.setState({
					dropdownDepartment: data
				})

			}).catch(
				error => console.error(`Error: ${error}`)
			)
	}
	ChangeTextSearch = (value) => {
		// console.log("value",value.target.value);
		this.setState({
			searchNameInternal: value.target.value
		})
	}
	ChangeGroup = (value) => {
		// console.log("value",value);
		if (value) {
			this.setState({
				groupCode: value,
				disableOther: true,
			})
		} else {
			this.setState({
				groupCode: "",
				disableOther: false,
			})
		}
	}
	ChangeOrg = (value) => {

		if (value) {
			this.setState({
				orgCode: value,
				valueSelectOrg: value,
				valueSelectDiv: "",
				valueSelectDep: "",
				dropdownDivision: [],
				dropdownDepartment: [],
				disableGroup: true
			})

			this.fetchListDiv(value);

		} else {
			this.setState({
				orgCode: "",
				valueSelectOrg: "",
				valueSelectDiv: "",
				valueSelectDep: "",
				dropdownDivision: [],
				dropdownDepartment: [],
				disableGroup: false
			})
		}

		// this.fetchListUser(value, this.state.limitpaginateGuset, 0, this.state.searchNameInternal);

	}
	ChangeDiv = (value) => {

		if (value) {
			this.setState({
				orgCode: value,
				valueSelectDiv: value,
				valueSelectDep: "",
				dropdownDepartment: [],
				disableGroup: true
			})

			this.fetchListDep(value);

		} else {
			this.setState({
				orgCode: "",
				valueSelectDiv: "",
				valueSelectDep: "",
				dropdownDepartment: [],
				disableGroup: false
			})
		}
		// this.fetchListUser(value, this.state.limitpaginateGuset, 0, this.state.searchNameInternal);

	}
	ChangeDep = (value) => {

		if (value) {
			this.setState({
				orgCode: value,
				valueSelectDep: value,
				disableGroup: true
			})

		} else {
			this.setState({
				orgCode: "",
				valueSelectDep: "",
				disableGroup: false
			})
		}

		// this.fetchListUser(value, this.state.limitpaginateGuset, 0, this.state.searchNameInternal);
		// console.log(`selected ${value}`);
	}
	onChangePage = page => {
		this.setState({
			currentPaginateGuset: page,
		});


      let item = document.getElementsByClassName("checkbox-listInviteInternal")

      for (let i = 0; i < item.length; i++) {
         console.log("pagxxxxe", item[i].getElementsByClassName("ant-checkbox"));
         item[i].getElementsByClassName("ant-checkbox")[0].classList.remove('ant-checkbox-checked');
      }
		this.fetchListUser(
         this.state.groupCode,
         this.state.orgCode,
         this.state.limitpaginateGuset,
         (page-1) * this.state.limitpaginateGuset,
         this.state.searchNameInternal,
         true
     );
	};

	confirmSearch = () => {
      this.setState({
         currentPaginateGuset: 1,
      });

		const orgCode = this.state.valueSelectDep
                ? this.state.valueSelectDep
                : this.state.valueSelectDiv
                    ? this.state.valueSelectDiv
                    : this.state.valueSelectOrg;

      console.log("this.state.groupCode", this.state.groupCode)

		this.fetchListUser(
            this.state.groupCode,
            orgCode,
            this.state.limitpaginateGuset,
            0,
            this.state.searchNameInternal
        );
	};

	onCheckAddInternal = async (e) => {
		if (e.target.checked) {
			this.setState({
				showlistInviteExternal: [{ "UserID": e.target.value }],
			})
		} else {
			const newshowlistInviteExternal = this.state.showlistInviteExternal.filter(element => element.UserID != e.target.value);
			this.setState({
				isCheckBox: "",
				showlistInviteExternal: newshowlistInviteExternal
			});
		}
		// console.log("showlistInviteExternal", this.state.showlistInviteExternal);
	}

	handleOkSaveInternal = async () => {

		this.props.clickAccept(this.state.id, this.state.showlistInviteExternal, this.state.note);
		this.handleCancel();
		this.setState({
			showModalChangeUser: false,
			showModalSuccess: true
		})
		setTimeout(() => {
			this.setState({
				showModalSuccess: false
			})
		}, 1000);
	}

	handleChangeNote = (event) => {
		this.setState({
				note:  event.target.value
		})
	}

	handleNextAddAttendeeInternal = async () => {
		this.setState({
				currentAddDelegateState: STATE.ADD_DELEGATE_NOTE
		})
	}

	handleBackAddAttendeeInternal = async () => {
		this.setState({
				currentAddDelegateState: STATE.ADD_DELEGATE_USER
		})
	}

	render() {
		const { dataMeeting } = this.props
		const { id, type } = this.state
		const { getFieldDecorator } = this.props.form;
		return (
			<Row gutter={16} >

				<Modal
					className={'meeting-management-modal'}
					visible={this.state.showModal}
					onCancel={this.handleCancel}
					footer={[
						<Button key="back" className={'btn-modal-cancle'} onClick={this.handleCancel}>
							ยกเลิก</Button>,
						<Button key="submit" className={'btn-modal-confirm'} onClick={this.handleOk}>
							ยืนยัน</Button>,
					]}
					closable={false}
				>
					<div align="center">
						{
							type == "JOIN" ?
								<p style={{ fontSize: "20px" }}>
									คุณตอบรับการเข้าร่วมประชุม<br />
									ใช่หรือไม่
								</p>
								:
								<p style={{ fontSize: "20px" }}>
									คุณปฏิเสธการเข้าร่วมประชุม<br />
									ใช่หรือไม่
								</p>
						}
					</div>
				</Modal>

				<Modal
					destroyOnClose={true}
					maskClosable={false}
					className={'list-invite-internal-modal'}
					visible={this.state.showModalChangeUser}
					onCancel={this.handleCancel}
					footer={
						this.state.currentAddDelegateState === STATE.ADD_DELEGATE_USER ?
						[
								<Button key="back" className={'btn-modal-cancle'} onClick={this.handleCancel}>ยกเลิก</Button>,
								<Button key="next" className={'btn-modal-confirm'} disabled={this.state.showlistInviteExternal.length === 0} onClick={this.handleNextAddAttendeeInternal}>ถัดไป</Button>
						] :
						[
								<Button key="back" className={'btn-modal-cancle'} onClick={this.handleBackAddAttendeeInternal}>ย้อนกลับ</Button>,
								<Button key="submit" className={'btn-modal-confirm'} disabled={this.state.showlistInviteExternal.length === 0 || this.state.note === ""} onClick={this.handleOkSaveInternal}>ยืนยัน</Button>,
						]
					}
				>
					{this.state.currentAddDelegateState === STATE.ADD_DELEGATE_USER ?
						<Row gutter={16}>
							<Spin tip="Loading..." size="large" spinning={this.state.loadingInternal} style={{ alignItems: 'center', position: 'initial' }}>
								<Col xs={24} className={'pb-3'}>
									<h1 className="mb-3">เพิ่มผู้เข้าร่วมภายใน</h1>
									<Input placeholder="ค้นหา" onChange={value => this.ChangeTextSearch(value)} />
								</Col>
								<Col className="mb-1" xs={24}>
									<h2 className="mb-1">กลุ่ม</h2>
									<Select
										defaultValue=""
										style={{ width: '100%' }}
										onChange={this.ChangeGroup}>
										<Option value=""><p style={{ color: "#d9d9d9" }}>กรุณาเลือกกลุ่ม</p></Option>
										{
											(this.state.dropdownGroup).map(item => (
												<Option value={item.id}>{item.groupName}</Option>
											))
										}
									</Select>
								</Col>
								<Col className='mb-1' xs={24}>
									<h2 className="mb-1">สำนัก</h2>
									<Select defaultValue="" style={{ width: '100%' }} onChange={this.ChangeOrg}>
										<Option value=""><p style={{ color: "#d9d9d9" }}>กรุณาเลือกสำนัก</p></Option>
										{
											(this.state.dropdownOrg).map(item => (
												<Option value={item.orgCode}>{item.orgName}</Option>
											))
										}

									</Select>
								</Col>
								<Col className='mb-1' xs={24}>
									<h2 className="mb-1">หน่วยงาน</h2>
									<Select disabled={!this.state.dropdownDivision.length > 0} defaultValue="" value={this.state.valueSelectDiv} style={{ width: '100%' }} onChange={this.ChangeDiv}>
										<Option value=""><p style={{ color: "#d9d9d9" }}>กรุณาเลือกฝ่าย</p></Option>
										{
											(this.state.dropdownDivision).map(item => (
												<Option value={item.divisionCode}>{item.divisionName}</Option>
											))
										}
									</Select>
								</Col>
								<Col className='mb-1' xs={24}>
									<h2 className="mb-1">แผนก</h2>
									<Select disabled={!this.state.dropdownDepartment.length > 0} defaultValue="" value={this.state.valueSelectDep} style={{ width: '100%' }} onChange={this.ChangeDep}>
										<Option value=""><p style={{ color: "#d9d9d9" }}>กรุณาเลือกแผนก</p></Option>
										{
											(this.state.dropdownDepartment).map(item => (
												<Option value={item.departmentCode}>{item.departmentName}</Option>
											))
										}
									</Select>
								</Col>
								<Col className="mt-3" xs={24}>
									<Button key="submit"
										disabled={!this.state.groupCode && !this.state.valueSelectOrg}
										className={'btn-modal-confirm w-100 mb-2'}
										onClick={this.confirmSearch}>
										ค้นหา</Button>
								</Col>
								{this.state.inviteInternal.length > 0 ? (
									<div>
										{this.state.inviteInternal.map((user, i) => {
											return (
												<Col key={user.empCode} xs={24} className={'py-1'}>
													<Checkbox 
                                          checked={this.state.isCheckBox == user.empCode} 
                                          onClick={() => { this.setState({ isCheckBox: user.empCode }) }} 
                                          onChange={(e) => this.onCheckAddInternal(e, user)}
														name={user.title + " " + user.firstName + " " + user.lastName} value={user.empCode}
                                          className="checkbox-listInviteInternal"
                                       >
														<p style={{ fontSize: "14px", display: "inline" }}>
                                             {user.title} {user.firstName} {user.lastName} {user.positionName ? `- ${user.positionName}` : user.positionName} {user.divisionName ? `- ${user.divisionName}` : user.divisionName}
                                          </p>
													</Checkbox>
												</Col>
											)
										})}
										{this.state.totalpaginateGuset != 0 ?
                                 <Col md={24} className={"pt-3"}>
                                    <Pagination 
                                       onChange={this.onChangePage}
                                       current={this.state.currentPaginateGuset} 
                                       total={this.state.totalpaginateGuset} 
                                    />
                                 </Col>
											:
											<></>
										}
									</div>)
									: this.state.isSearch ?
										<Col xs={24} md={24} align={"center"}>
											<Text>ไม่พบข้อมูลรายการ</Text>
										</Col>
										: <></>
								}
							</Spin>
						</Row>
						: 
						<Row gutter={16}>
								<Spin tip="Loading..." size="large" spinning={this.state.loadingInternal} style={{ alignItems: 'center', position: 'initial' }}>
										<Col className='mb-2' xs={24}>
												<h2>เหตุผลในการส่งตัวแทน</h2>
												<TextArea rows={4} value={this.state.note} onChange={this.handleChangeNote}></TextArea>
										</Col>
								</Spin>
						</Row>
					}
				</Modal>
				<Modal
					className={'meeting-management-modal'}
					visible={this.state.showModalSuccess}
					onCancel={this.handleCancel}
					footer={null}
					closable={false}
				>
					{type == "JOIN" ?
						<div className={'py-5'} style={{ textAlign: 'center', color: "#178991" }}>
							<Icon style={{ fontSize: "70px", paddingBottom: "30px" }} type="check-circle" />
							<p style={{ fontSize: "20px" }}>
								เข้าร่วมการประชุมสำเร็จ
							</p>
						</div>
						:
						<>
							{type == "REFUSE" ?
								<div className={'py-5'} style={{ textAlign: 'center', color: "#d7222a" }}>
									<Icon style={{ fontSize: "70px", paddingBottom: "30px" }} type="close-circle" />
									<p style={{ fontSize: "20px" }}>
										ปฏิเสธการประชุม
									</p>
								</div>
								:
								<div className={'py-5'} style={{ textAlign: 'center', color: "##666666" }}>
									<Icon style={{ fontSize: "70px", paddingBottom: "30px" }} type="swap" />
									<p style={{ fontSize: "20px" }}>
										ส่งตัวแทนเข้าร่วมการประชุมสำเร็จ
									</p>
								</div>
							}
						</>
					}
				</Modal>
				{dataMeeting && dataMeeting.length > 0 ?
					dataMeeting.map((MeetingList, i) => {
						const meetingStatus = MeetingList.Guests[0].status
						const isDelegate = (MeetingList.Guests[0].delegateID !== null || MeetingList.Guests[0].isDelegate)
						return (
							<Col span={24} className={"box-show-meeting p-3 pl-4 my-3"}>
								<Row gutter={16} justify="end" style={{ borderLeft: "8px solid", borderColor: (meetingStatus == "WAITING" ? "#FDB75D" : (meetingStatus == "REFUSE" ? "#D94339" : (meetingStatus == "JOIN" ? "#178991" : "#B3B3B3"))) }}>
									<Col span={16} className="pl-3">
										<p className={"text-box-meeting"}><Icon className="icon-box-meeting" type="sound" />{MeetingList.subject}</p>
									</Col>
									<Link
										to={{
											pathname: `/meetingmanagement/inviteMeetingForm/`,
											search: 'id=' + MeetingList.id,
										}}>
										<Col span={7} align="end">
											<Icon type="right" style={{ color: "#666666" }} />
										</Col>
									</Link>
									<Col span={16} className="pl-3">
										<p className={"text-box-meeting"}><Icon className="icon-box-meeting" type="clock-circle" />{changeFormatdateSlip(moment(MeetingList.startDate))} / {moment(MeetingList.startDate).format('HH:ss')} - {moment(MeetingList.endDate).format('HH:ss')} น.</p>
									</Col>
									<Col span={7}>

									</Col>
									<Col span={12} className="pl-3">
										<p className={"text-box-meeting"}><Icon className="icon-box-meeting" type="environment" />{MeetingList.location}</p>
									</Col>
									{MeetingList.Guests[0].status == "WAITING" ?
										<>
											<Col span={4} align="end" offset={ isDelegate ? 4 : 0}>
												<Button onClick={e => this.clickChange(MeetingList.id, "REFUSE")} className={'button-meeting-approve mt-3 mt-lg-0'} style={{ color: "#ffffff", backgroundColor: "#D94339" }}>
													ปฏิเสธ</Button>
											</Col>
                                 {!isDelegate &&
                                    <Col span={4} align="end">
                                       <Button onClick={e => this.handleChangeUser(MeetingList.id, "AGENT")} className={'button-meeting-approve mt-3 mt-lg-0 show-border'} style={{ color: "#808080", backgroundColor: "transparent", borderColor:"1px solid #808080 !important" }}>
                                          ส่งตัวแทน</Button>
                                    </Col>
                                 }
											<Col span={4} align="end">
												<Button onClick={e => this.clickChange(MeetingList.id, "JOIN")} className={'button-meeting-approve mt-3 mt-lg-0'} style={{ color: "#ffffff" }}>
													ตอบรับ</Button>
											</Col>
										</>
										:
										<></>
									}
									{MeetingList.Guests[0].status == "JOIN" ?
										<>
											{!isDelegate ? 
                                    <Col span={4} align="end" offset={ 4 }>
                                       <Button onClick={e => this.handleChangeUser(MeetingList.id, "AGENT")} className={'button-meeting-approve mt-3 mt-lg-0 show-border'} style={{ color: "#808080", backgroundColor: "transparent"}}>
                                          ส่งตัวแทน</Button>
                                    </Col>
                                 :
                                    <Col span={4} align="end" offset={ 4 }>
                                       <Button disabled={true} onClick={e => this.clickChange(MeetingList.id, "JOIN")} className={'button-meeting-approve mt-3 mt-lg-0'} style={{ color: "#808080", backgroundColor: "transparent" }}>
                                          ตอบรับ</Button>
                                    </Col>}
											<Col span={4} align="end">
												<Button onClick={e => this.clickChange(MeetingList.id, "REFUSE")} className={'button-meeting-approve mt-3 mt-lg-0'} style={{ color: "#ffffff", backgroundColor: "#D94339" }}>
													ปฏิเสธ</Button>
											</Col>
										</>
										:
										<></>
									}
									{MeetingList.Guests[0].status == "REFUSE" ?
										<>
											{!isDelegate ? 
                                    <Col span={4} align="end" offset={ 4 }>
                                       <Button onClick={e => this.handleChangeUser(MeetingList.id, "AGENT")} className={'button-meeting-approve mt-3 mt-lg-0'} style={{ color: "#808080", backgroundColor: "transparent", borderColor:"1px solid #808080 !important" }}>
                                          ส่งตัวแทน</Button>
                                    </Col>
												:
												<Col span={4} align="end" offset={ 4 }>
													<Button disabled={true} onClick={e => this.clickChange(MeetingList.id, "REFUSE")} className={'button-meeting-approve mt-3 mt-lg-0'} style={{ color: "#808080", backgroundColor: "transparent" }}>
														ปฏิเสธ</Button>
												</Col>}
											<Col span={4} align="end">
												<Button onClick={e => this.clickChange(MeetingList.id, "JOIN")} className={'button-meeting-approve mt-3 mt-lg-0'} style={{ color: "#ffffff" }}>
													ตอบรับ</Button>
											</Col>
										</>
										:
										<></>
									}
									{MeetingList.Guests[0].status == "AGENT" ?
										<>
											<Col span={4} align="end" offset={ 4 }>
												<Button onClick={e => this.clickChange(MeetingList.id, "REFUSE")} className={'button-meeting-approve mt-3 mt-lg-0'} style={{ color: "#808080", backgroundColor: "transparent" }}>
													ปฏิเสธ</Button>
											</Col>
											<Col span={4} align="end">
												<Button onClick={e => this.clickChange(MeetingList.id, "JOIN")} className={'button-meeting-approve mt-3 mt-lg-0'} style={{ color: "#808080", backgroundColor: "transparent" }}>
													ตอบรับ</Button>
											</Col>
										</>
										:
										<></>
									}

								</Row>
							</Col>
						)
					})
					:
					<Col xs={24} md={24} align={"center"} style={{ marginTop: "150px" }}>
						<Text>ไม่พบข้อมูล</Text>
					</Col>}
				<Col xs={{ span: 24, offset: 0 }}>
					{/*{dataMeeting}*/}
				</Col>
			</Row>
		)
	}
}


ViewInviteMeeting.propTypes = {
	afterSubmit: PropTypes.func,
	forgotLink: PropTypes.string,
	autoFocus: PropTypes.bool
}

const WrappedAddMeeting = Form.create()(ViewInviteMeeting)

export default withApollo(WrappedAddMeeting)